__turbopack_context__.v({
  "counter": "gallery-viewer-module__WJXGjG__counter",
  "counterCurrent": "gallery-viewer-module__WJXGjG__counterCurrent",
  "counterSep": "gallery-viewer-module__WJXGjG__counterSep",
  "counterTotal": "gallery-viewer-module__WJXGjG__counterTotal",
  "gv-fade-in": "gallery-viewer-module__WJXGjG__gv-fade-in",
  "gv-spin": "gallery-viewer-module__WJXGjG__gv-spin",
  "gv-zoom-in": "gallery-viewer-module__WJXGjG__gv-zoom-in",
  "header": "gallery-viewer-module__WJXGjG__header",
  "iconBtn": "gallery-viewer-module__WJXGjG__iconBtn",
  "image": "gallery-viewer-module__WJXGjG__image",
  "imageWrap": "gallery-viewer-module__WJXGjG__imageWrap",
  "navBtn": "gallery-viewer-module__WJXGjG__navBtn",
  "navNext": "gallery-viewer-module__WJXGjG__navNext",
  "navPrev": "gallery-viewer-module__WJXGjG__navPrev",
  "spinner": "gallery-viewer-module__WJXGjG__spinner",
  "spinnerRing": "gallery-viewer-module__WJXGjG__spinnerRing",
  "stage": "gallery-viewer-module__WJXGjG__stage",
  "thumb": "gallery-viewer-module__WJXGjG__thumb",
  "thumbActive": "gallery-viewer-module__WJXGjG__thumbActive",
  "thumbs": "gallery-viewer-module__WJXGjG__thumbs",
  "title": "gallery-viewer-module__WJXGjG__title",
  "viewer": "gallery-viewer-module__WJXGjG__viewer",
});
